import { atom } from "recoil";
import { SggUser } from "../login/SggUser";
import { localStoragePersistenceEffect } from "../atomEffects/localStoragePersistenceEffect";

const key = "sgg_user";

export const sggUserAtom = atom<SggUser | undefined>({
  key,
  default: undefined,
  effects: [localStoragePersistenceEffect(key)],
});
